import { createFileRoute } from "@tanstack/react-router";
import { DisplayPage } from "@/pages/display.page";

export const Route = createFileRoute("/display/$slug")({
  component: DisplayPage,
  validateSearch: (search: Record<string, unknown>) => ({
    auth: typeof search.auth === "string" ? search.auth : undefined,
    debugShell:
      search.debugShell === true ||
      (typeof search.debugShell === "string" && ["1", "true", "yes", "on"].includes(search.debugShell.toLowerCase())),
  }),
});
